import apiClient from "./APIClient";

class BulkStockTransferService {
  getDownlineAgents = async () => {
    return await apiClient.get("/merchant-downlineAgent/childAgents");
  }

  bulkStockTransfer = async (formData) => {
    return await apiClient.post("/transferStock-toDownline/bulk-stock-transfer", formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
  }

  downloadFailedTemplate = async () => {
    return await apiClient.get("/transferStock-toDownline/download-template", {
      responseType: 'blob'
    });
  }
}

export default new BulkStockTransferService();